export default __webpack_public_path__ + "static/media/baby.e31e649c.svg";